/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: Index
 * Page name: Home page
 * Page Description: This is the home page of the website of Ekathva Innovations, it consists of all the
 * brief details about the company and its business.
*/


import React, { useEffect, useState } from "react";
import MetaTags from 'react-meta-tags'
import Aos from 'aos'
import "aos/dist/aos.css"
import { Row, Col, Card, CardTitle, CardText,Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Image } from 'react-bootstrap'
import { Link } from "react-router-dom";
import { Carousel } from 'react-bootstrap'

import 'assets/style/Style.css'

import {ReactComponent as Plus} from "assets/images/AllPage/Plus.svg"

// core components
import Navbar from "components/Navbars/Navbar.js";
import IndexHeader from "components/Headers/IndexHeader"
import Footer from "components/Footers/Footer.js";

// sections for this page
import Clients from "views/Clients"
import Testi from "views/Testi"

//ProductsImage

import SmartValve from "assets/images/Products/SmartValve/SV1.jpeg"
import SML from "assets/images/OurProducts/SML.jpg"
import DTRACKER from "assets/images/OurProducts/Dtracker.jpg"
import ITL from "assets/images/OurProducts/ITL.jpg"
import GDB from "assets/images/OurProducts/GDB.jpg"
import PRM from "assets/images/OurProducts/PRM.jpg"
import InternshipImage from "assets/images/OurProducts/QuestLearn.png";

import PlusGif from 'assets/images/AllPage/Plus_GIF.gif'

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop)

function Index() {

  useEffect( () => {
    window.scrollTo(0, 0)
    Aos.init({ duration: 1000})
  }, [])

  React.useEffect(() => {
    document.body.classList.add("index-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("index-page");
      document.body.classList.remove("sidebar-collapse");
    };
  });

  const responsive = {
    superLargeDesktop: {

      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const resp = {
    superLargeDesktop: {

      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  let imgs = [
    'https://drive.google.com/file/d/1qf5LCHS0xBbYrZ6JHqd688wM_0OyEPiE/view?usp=sharing',
    'https://res.cloudinary.com/stealthman22/image/upload/v1586308023/new-portfolio/hero/two-cargo-ships-sailing-near-city-2144905.jpg',
  ];

  const [modal, setModal] = useState(true);

  const toggle = () => setModal(!modal);


  return (
    <>

    <MetaTags>
    <title>Ekathva Innovations Pvt Ltd | Embedded Systems, IoT, PCB | Website development, Web/Mobile Application Development, Software, IT Services in Shivamogga</title>
    <meta name="description" content="Ekathva Innovations is an R&D based startup, which is one of the leading Embedded Systems, IoT, PCB designing, Website, Mobile App and Software development company in Shivamogga and Hubballi. We provide services and also banks some in house products in the field of Embedded systems, IoT, Automation, IT, Software, Mobile application and also affordable technology for Agri-Tech sectors." />
    <meta name="keywords" content="Ekathva, Ekathva Innovations, Embedded Services company in Shivamogga, Embedded Solutions company in Shivamogga, Embedded System company in Shivamogga, IoT company in Shivamogga, Internet of Things company in Shivamogga, PCB company in Shivamogga, PCB designing company in Shivamogga, PCB fabrication company in Shivamogga, Printed Circuit Boards company in Shivamogga, Agritech company in Shivamogga, Agri-Tech, Electronics  company in Shivamogga, Web company in Shivamogga, Websites company in Shivamogga, Mobile App company in Shivamogga, Android Application company in Shivamogga, Software Solution company in Shivamogga, Softwares company in Shivamogga, IT Solution company in Shivamogga, IT services company in Shivamogga, Research and Development company in Shivamogga, R&D company in Shivamogga, best website in shivamogga, best software company in shivamogga, Enterprise Softwares in shivamogga, Best PCB in shivamogga, Startup in shivamogga, Internships company in Shivamogga, Technical Workshops in shivamogga, EI-Learn, EI, Technical company in Shivamogga, Trainings company in Shivamogga, Shivamogga, Shimoga, Hubballi, Hubli, Deshpande Startups, Deshpande Foundation" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
    </MetaTags>
    <Navbar />

    <div className="wrapper">
    <IndexHeader />
    <div className="main">
    {/* <Navbar/>*/}

    {/* <div className="internship_banner">
        <h2>
        <strong>
        <em>Internship-2023</em>
        </strong>
        </h2>
        <Link onClick={toggle} class="cta1" style={{ textDecoration: 'none' }}>
        <span>View Details</span>
        <svg width="13px" height="10px" viewBox="0 0 13 10">
        <path d="M1,5 L11,5"></path>
        <polyline points="8 1 12 5 8 9"></polyline>
        </svg>
        </Link>
    </div> */}

    <div>
    <div className='homepage_spacing' >
    <Row>
    <Col xs lg="5" data-aos="fade-up-right" className='mainhomepage_colspacing1'>
    <h4>
    About <span className='aboutus_fontbold'>Ekathva Innovations</span>

    </h4>
    <p>
    <strong>
    <br/>
    At Ekathva Innovations, we bring you with a team of professionals having expertise in the field of
    Embedded systems, Printed Circuit Boards, IoT,  Website Development, Mobile App Development and Digital
    transformations to develop User-Friendly and Affordable Products and Services.
    <br /><br/>
    Our Research and Development is focused on Agri-Tech, Automotive Electronics, Industrial 4.0, Internet
    of Things, and Enterprise Softwares. The company also banks on some in-house products and is always a step
    forward in satisfying customer needs.
    <br />
    </strong>
    </p>
      <br />
    <Link to="/about-us" class="cta" style={{ textDecoration: 'none' }}>
    <span>Know Better</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </Col>

    <Col data-aos="fade-up-left" className='mainhomepage_colspacing2'>
    <br/>
    <h4 className='aboutus_fontsitallic' >Here's a little bit about our services we deliver best</h4>
    <br/>
    <Col>
    <Card body>
    <CardTitle tag="h5" >
    <Row>
    <Col>
    <span className='aboutus_fontbold'>Embedded </span>
    <span>Services </span>
    <Link to="/embedded-services">
    <Plus class="rounded mx-auto homepage_plussize" />
    </Link>
    </Col>

    </Row>
    </CardTitle>
    <CardText >
    <p className='mainhomepage_cardtextsize'>
    <strong>
    We provide the best embedded services at affordable cost, from embedded hardware development,
    firmware development to knowledge-based training and upskilling.
    </strong>
    </p>
    </CardText>
    </Card>
    </Col>

    <Col>
    <Card body>
    <CardTitle tag="h5">
    <Row>
    <Col>
    <span className='aboutus_fontbold'>IT </span>
    <span>Services </span>
    <Link to="/it-services">
    <Plus class="rounded mx-auto homepage_plussize" />
    </Link>
    </Col>
    </Row>
    </CardTitle>
    <CardText >
    <p className='mainhomepage_cardtextsize'>
    <strong>
    We create outstanding, interactive, user friendly, responsive web and mobile applications,
    customized software solutions for a wide range of  businesses from frontend
    to backend and everything in between.
    </strong>
    </p>

    </CardText>
    </Card>
    </Col>
    </Col>
    </Row>
    <br/><br/>
    </div>

    <div className='homepageproducts_spacing homepage_spacing' >

    <h3 data-aos="fade-right">
    Ekathva <span className='aboutus_fontbold'>Products </span>
    <Link to="/products">
    <Plus class="rounded mx-auto homepage_plussize" />
    </Link>
    </h3>

    <p data-aos="fade-right" className='aboutus_fontsitallic' >
    <strong>Products we crafted with love for the community and its betterment!</strong>
    </p>

    <Carousel>
    <Carousel.Item interval={5000}>

    <Row>
    <Col md={4}>
    <Card style={{width:300}}>
    <img src={SmartValve} alt="Smart Valve Controller" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div className='homepageproducts_headingspace aboutus_textalign' >
    <h6 className='aboutus_fontbold aboutus_textalign'>Smart Irrigation Controller</h6>
    </div>
    <div className='homepageproducts_headingspace aboutus_textalign'>
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col>

    <Col md={4}>
    <Card style={{width:300}}>
    <Image img src={SML} alt="Moisture Logger" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div  className='homepageproducts_headingspace aboutus_textalign'>
    <h6 className='aboutus_fontbold aboutus_textalign'>Smart Moisture Logger</h6>
    </div>
    <div className='homepageproducts_headingspace aboutus_textalign'>
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col>

    <Col md={4}>
    <Card style={{width:300}}>
    <Image img src={DTRACKER} alt="D-Tracker Software" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div className='homepageproducts_headingspace aboutus_textalign' >
    <h6 className='aboutus_fontbold aboutus_textalign'>D-Tracker</h6>
    </div>
    <div className='homepageproducts_headingspace aboutus_textalign' >
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col>

    {/* <Col md={4}>
    <Card style={{width:300}}>
    <Image img src={ITL} alt="IoT Hardware for Industry 4.0" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <h6 className='aboutus_fontbold aboutus_textalign' >Industrial Time Logger</h6>
    </div>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col>

    <Col md={4}>
    <Card style={{width:300}} >
    <Image img src={GDB} alt="General Development Board Photo" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <h6 className='aboutus_fontbold aboutus_textalign' >GDB</h6>
    </div>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col>

    <Col md={4}>
    <Card style={{width:300}} >
    <Image img src={PRM} alt="Power supply module" className='homepageproducts_imagesize' />
    <CardTitle className='carouselBottomMargin'>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <h6 className='aboutus_fontbold aboutus_textalign'>Power Supply Regulator</h6>
    </div>
    <div className='homepageproducts_headingspace  aboutus_textalign' >
    <Link to="/products" class="cta" style={{ textDecoration: 'none' }}>
    <span className="fontSize">Know More</span>
    <svg width="13px" height="10px" viewBox="0 0 13 10">
    <path d="M1,5 L11,5"></path>
    <polyline points="8 1 12 5 8 9"></polyline>
    </svg>
    </Link>
    </div>
    </CardTitle>
    </Card>
    </Col> */}

    </Row>

    </Carousel.Item>
    </Carousel>

    </div>

    <br/><br/><br/>
    <div className='homepage_spacing' >
    <h3 data-aos="fade-up">Our Previleged <span className='aboutus_fontbold' >Clients </span>
    <Link to="/our-clients">
    <Plus class="rounded mx-auto homepage_plussize" />
    </Link>
    </h3>
    <div>
    <p data-aos="fade-right" className='aboutus_fontsitallic'>
    <strong>We put our heart in our work and our clients love working with us!</strong>
    </p>

    <div  data-aos="fade-left" >

    <Clients/>

    </div>
    </div>
    </div>

    <br/><br/><br/>

    <div className='homepage_spacing' >
    <h3 data-aos="fade-right" className='aboutus_fontbold'>
    Testimonials <Link to="/testimonials">
    <Plus class="rounded mx-auto homepage_plussize" />
    </Link>
    </h3>
    <p data-aos="fade-right" className='aboutus_fontsitallic' >
    <strong>We delivered the best work and our clients spoke positively about it!</strong>
    </p>
    <Testi/>

    </div>
    </div>

    </div>

    <Footer />

    </div>

    {/* <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>
      <div align="center">
        <h2><strong>Internship-2023</strong></h2>
      </div>
      </ModalHeader>
      <ModalBody>
      <div>
      <img src={InternshipImage} alt="Smart Valve Controller" width="100%" />
      </div>
      <br/>
      <div className="internship_modal" align="center">
      <a href="https://drive.google.com/file/d/1R2cjmQuPS6v35bTTb2Jni1oGvMvJEsC-/view?usp=sharing" target="_blank" class="cta2" style={{ textDecoration: 'none' }}>
      <span className="fontSize">View Details</span>
      <svg width="13px" height="10px" viewBox="0 0 13 10">
      <path d="M1,5 L11,5"></path>
      <polyline points="8 1 12 5 8 9"></polyline>
      </svg>
      </a>
      <a href="https://forms.gle/noWvaHXy6VMtwb2Z9" target="_blank" class="cta2" style={{ textDecoration: 'none' }}>
      <span className="fontSize">Register Here</span>
      <svg width="13px" height="10px" viewBox="0 0 13 10">
      <path d="M1,5 L11,5"></path>
      <polyline points="8 1 12 5 8 9"></polyline>
      </svg>
      </a>
      <br/><br/>
      </div>
      </ModalBody>
    </Modal> */}

    </>
  );
}

export default Index;
